<h2 mat-dialog-title data-testid="cipo-undo-transition-dialog-title">{{ data.title | translate }}</h2>
<mat-dialog-content>
    <div class="p-t" data-testid="cipo-undo-transition-dialog-content">
        @if (rolesLoading()) {
            <ngx-skeleton-loader [theme]="{ width: '100%', height: '64px', margin: '0 0 8px' }"></ngx-skeleton-loader>
            <div class="p-t-lg" fxLayout="column" fxLayoutGap="12px">
                <ngx-skeleton-loader [theme]="{ width: '100%', height: '40px', margin: '0' }"></ngx-skeleton-loader>
                <ngx-skeleton-loader [theme]="{ width: '100%', height: '40px', margin: '0' }"></ngx-skeleton-loader>
            </div>
        } @else {
            @if (data.message?.length) {
                <p [innerHTML]="data.message | translate"></p>
            }
            @if (userRoles()?.length) {
                <div class="p-t-lg" fxLayout="column" fxLayoutGap="12px">
                    <cipo-checkbox
                        [control]="form.controls.notify"
                        [fieldData]="{ label: 'dm.undoLastAction.notifyUsers' }"
                        data-testid="cipo-undo-transition-dialog-notify-checkbox" />

                    <cipo-select
                        [fieldData]="notifyUsersConfig()"
                        [control]="form.controls.notifyUsers"
                        data-testid="cipo-undo-transition-dialog-notify-users-select" />
                </div>
            }
        }
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button data-testid="cipo-undo-transition-dialog-cancel-action" [mat-dialog-close]="null">
        {{ "general.no" | translate }}
    </button>
    <button
        mat-raised-button
        data-testid="cipo-undo-transition-dialog-confirm-action"
        [mat-dialog-close]="getDialogResult()"
        color="accent"
        cdkFocusInitial>
        {{ "general.yes" | translate }}
    </button>
</mat-dialog-actions>
